<div class="progressbaractivatiegraad">
  <canvas *ngIf="barChartData" baseChart
          [datasets]="barChartData"
          [options]="barChartOptions"
          [legend]="barChartLegend"
          [chartType]="barChartType">
  </canvas>
  <span *ngIf="percentage >= 0" class="percentage">{{ percentage <= 100 ? percentage + '%' : '>100%' }}</span>
</div>
